import { useEffect, useRef } from "react"
import styles from "./FilterDrawer.module.css"
import { FilterPanel } from "./FilterPanel.js"
import type { FilterCounts } from "./filterBenefits.js"
import { countActiveFilters } from "./filterConstants.js"
import type { Filters } from "./useBenefits.js"

interface Props {
  open: boolean
  filters: Filters
  counts: FilterCounts | null
  onChange: (partial: Partial<Filters>) => void
  onClose: () => void
}

export function FilterDrawer({ open, filters, counts, onChange, onClose }: Props) {
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose
  const activeCount = countActiveFilters(filters)

  useEffect(() => {
    if (!open) return

    document.body.style.overflow = "hidden"
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") onCloseRef.current()
    }
    document.addEventListener("keydown", onKeyDown)
    return () => {
      document.body.style.overflow = ""
      document.removeEventListener("keydown", onKeyDown)
    }
  }, [open])

  return (
    <div className={`${styles.root} ${open ? styles.open : ""}`} aria-hidden={!open}>
      <button
        type="button"
        className={styles.backdrop}
        aria-label="閉じる"
        tabIndex={open ? 0 : -1}
        onClick={onClose}
      />
      <aside className={styles.panel} aria-labelledby="filter-drawer-title">
        <div className={styles.header}>
          <h2 id="filter-drawer-title" className={styles.title}>
            絞り込み
            {activeCount > 0 && <span className={styles.badge}>{activeCount}</span>}
          </h2>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            閉じる
          </button>
        </div>
        <div className={styles.body}>
          <FilterPanel
            variant="full"
            resetScope="exceptQuery"
            namePrefix="drawer-"
            filters={filters}
            counts={counts}
            onChange={onChange}
          />
        </div>
      </aside>
    </div>
  )
}
